export default __webpack_public_path__ + "static/media/Head_3_Ear_2_C5.196f35a3.svg";